export enum Claims {
    //DB - Permission Table
    accept_deny_others_pos = 89,
    create_lot_schedule = 10,
    change_trade_partner = 9,
    change_baseline_date = 50,
    community_management_view = 22,
    community_management_edit = 23,
    construction_updates = 88,
    edit_lot_config_info = 3,
    field_contact_dropdown_availability = 73,
    field_contact_management = 86,
    limit_scar_completions = 70,
    manage_accounting_units = 64,
    manage_approval_hierarchies = 76,   
    manage_approval_limits = 42,
    manage_approval_limit_caps = 66,
    manage_baseline_date = 8,
    manage_co = 11,
    manage_co_notifications = 82,
    manage_completions = 4,
    manage_completions_restriction = 91,
    manage_divisionreorg = 80,
    manage_documents = 18,
    manage_employee_managers = 52,
    manage_email_notifications = 81,
    manage_housewip_accounts = 65,
    manage_lot_recordables = 55,
    manage_owned_lot_recordables = 87,
    manage_markets = 30,
    manage_overhead_accounts = 61,
    manage_purchase_orders = 41,
    manage_purchase_orders_market_management = 68,
    manage_recordable_categories = 56,    
    manage_schedule_components = 5,
    manage_schedules = 2,
    manage_setup = 14,
    manage_subgroup = 15,
    manage_tasks = 6,
    manage_templates = 21,
    manage_todays_schedules = 90,
    manage_trade_partners = 69,
    manage_users = 24,
    manage_user_settings = 27,
    mass_change_completions = 83,
    mass_change_completions_limited_adjustments = 84,
    mass_change_edit = 13,
    mass_change_trade_partner = 85,
    mass_change_view = 12,
    run_reports = 19,
    view_configured_schedules = 1,
    view_documents = 17,
    view_jio_co = 34,
    view_purchase_orders = 40,
    view_recordables = 53,
    view_setup_info = 16,
    view_templates = 20,
    void_others_pos = 77,

    //Internal to PCP
    azureGUID = 101,
    edhUserId = 105,
    isAuthenticated = 104,
    orgAll = 106,
    userDisplayName = 102,
    userOrgs = 103  
}
